module.exports = __webpack_public_path__ + "images/066e8dffeac01e1f9decae08d2c6b45b.svg";